import { EBetType } from '../constants';
import { getCombinationsCount } from './getCombinationsCount';

const MIN_EXPRESS_EVENTS = 2;
const MIN_ALLEXPRESS_EVENTS = 2;


const sumCombinations = (eventsCount: number, fromIndex: number, toIndex: number): number => {
    let total = 0;
    for (let i = fromIndex; i < toIndex; i++) {
        total += getCombinationsCount(eventsCount, i);
    }
    return total + 1;
};

const getBetCombinationsCount = (
    type: EBetType,
    eventsCount: number,
    expressEvents?: number
): number => {
    switch (type) {
        case EBetType.Single:
        case EBetType.Express:
            return 1;
        case EBetType.System:
            return getCombinationsCount(
                eventsCount,
                expressEvents ?? MIN_EXPRESS_EVENTS
            );
        case EBetType.AllExpressesExceptSingle:
            return sumCombinations(eventsCount, MIN_ALLEXPRESS_EVENTS, eventsCount);
        case EBetType.AllExpresses:
            return sumCombinations(eventsCount, MIN_ALLEXPRESS_EVENTS, eventsCount) + eventsCount;
        default:
            return 0;
    }
};

export {
    getBetCombinationsCount
}
